import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export async function getClients() {
    const res = await axios({
        url: [API, "/clients"].join(""),
        method: "GET",
        withCredentials: true,
    });
    return Array.isArray(res.data?.data) ? res.data.data : [];
}

export async function getClientEmissionCategories(clientId) {
    const res = await axios({
        url: [API, "/client-emission-category"].join(""),
        method: "GET",
        withCredentials: true,
        params: { clientId },
    });
    return Array.isArray(res.data?.data) ? res.data.data : [];
}

export async function addClientEmissionCategory({ clientId, categoryId }) {
    await axios({
        url: [API, "/client-emission-category-create"].join(""),
        method: "POST",
        withCredentials: true,
        data: { clientId, categoryId },
    });
}

export async function deleteClientEmissionCategory({ id }) {
    await axios({
        url: [API, "/client-emission-category-delete"].join(""),
        method: "POST",
        withCredentials: true,
        data: { id },
    });
}

export async function getClientCategoryFactors(clientId, categoryId) {
    const res = await axios({
        url: [API, "/client-category-factor"].join(""),
        method: "GET",
        withCredentials: true,
        params: { clientId, categoryId },
    });
    return Array.isArray(res.data?.data) ? res.data.data : [];
}

// --- CREATE factor mapping for industry-category ---
export async function addClientCategoryFactor({ clientId, categoryId, factorId }) {
    await axios({
        url: [API, "/client-category-factor-create"].join(""),
        method: "POST",
        withCredentials: true,
        data: { clientId, categoryId, factorId },
    });
}

// DELETE factor mapping for an industry-category (assumes body { id })
export async function deleteClientCategoryFactor({ id }) {
    await axios({
        url: [API, "/client-category-factor-delete"].join(""),
        method: "POST",
        withCredentials: true,
        data: { id },
    });
}

// Toggle visibility of a client's assigned emission factor
export async function setClientCategoryFactorAvailability({ id, available }) {
    await axios({
        url: [API, "/client-category-factor-visibility-update"].join(""),
        method: "POST",
        withCredentials: true,
        data: { id, available },
    });
}

export async function getClientEmissionRecords({
    clientId,
    categoryId,
    factorId,
    limit = 2000,
    offset = 0,
}) {
    const res = await axios({
        url: [API, "/client-emission-record"].join(""),
        method: "GET",
        withCredentials: true,
        params: {
            clientId,
            categoryId,
            factorId,
            limit,
            offset,
        },
    });
    return Array.isArray(res.data?.data) ? res.data.data : [];
}

export async function updateClientEmissionRecordFactor({
    recordIds,
    factorId,
    factorVersion,
}) {
    const res = await axios({
        url: [API, "/client-emission-record-factor-update"].join(""),
        method: "POST",
        withCredentials: true,
        data: {
            recordIds,
            factorId,
            factorVersion,
        },
    });
    return res.data;
}


